import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CHECKOUT_PAGES_ACTION_TYPES } from "repoV2/features/CheckoutPages/constants/CheckoutPagesReducer";
import { IPriceSummary } from "repoV2/features/CheckoutPages/interfaces/CheckoutPages.interface";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { roundOff } from "repoV2/features/Common/utils/numbers";

/**
 * Setter to set the total and strike off amount to redux
 * @param totalAmount - The total amount to show to user, inclusive of all discounts and offers
 * @param strikeOffAmount - The total amount exclusive of the discounts and offers
 */
export const useSetPriceSummary = ({
    totalAmount,
    strikeOffAmount,
}: {
    totalAmount: number;
    strikeOffAmount: number;
}) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (totalAmount >= 0 && strikeOffAmount >= 0) {
            dispatch({
                type: CHECKOUT_PAGES_ACTION_TYPES.SET_PRICE_SUMMARY_DATA,
                payload: {
                    totalAmount: roundOff(totalAmount),
                    strikeOffAmount: roundOff(strikeOffAmount),
                },
            });
        }
    }, [totalAmount, strikeOffAmount]);
};

/**
 * Getter to get the total and strike off amount from checkout page redux
 * @returns object containing totalAmount and strikeOffAmount
 */
export const useGetPriceSummary = () => {
    const { totalAmount, strikeOffAmount }: IPriceSummary = useSelector(
        (state: IRepoV2ReduxState) => state.checkoutPages.priceSummary
    );

    return {
        totalAmount,
        strikeOffAmount,
    };
};
